<template>
	<section class="sk-simple">
		<header class="sk-simple__header">
			<div class="sk-simple__highlight">Bem-vindo à solução IoT</div>
		</header>
		<main class="sk-simple__wrapper">
			<div class="sk-simple__panel">
				<main class="sk-simple__content">
					<div class="sk-simple__content_header">
						<img src="static/img/pt/logoe.png" alt="" class="sk-simple__logo-e">
						<div class="sk-simple__content-title">Smart Care</div>
					</div>
					<router-view id="content"/>
				</main>
			</div>
		</main>
		<footer class="sk-simple__footer">
			<!-- <img class="sk-simple__logo" src="static/img/pt/logo.png" alt=""> -->
			<div class="sk-simple__logo-text">Smart Care | Todos os direitos reservados</div>
			<a class="sk-simple__link-pp" target="_blank" href="https://www.telecom.pt/pt-pt/Paginas/politica-privacidade.aspx">Política de Privacidade</a>
		</footer>
	</section>
</template>

<script>
export default {
	name: 'app-shell-simple'
}
</script>

<style scope>

.sk-simple {
	width: 100vw;
	height: 100vh;
	display: grid;
	grid-template-rows: 100px 1fr 50px;
	align-items: center;
	justify-items: center;
	background: linear-gradient(45deg, #dff7f9, #72bdc1);
	background-image: url('/static/img/pt/bg.jpg');
	background-repeat: no-repeat;
	background-size: cover;
	background-position: right center;
	overflow-y: auto;
}

.sk-simple__wrapper {
	padding: 10px;
	width: 100%;
	max-width: 400px;
	_margin-right: 200px;
}

.sk-simple__panel {
	display: grid;
	grid-template-columns: 1fr;
	height: 100%;
	background-color: rgba(255,255,255,0.75);
	box-shadow: rgba(0,0,0,0.1) 0 0 12px;
	border-radius: 3px;
	overflow: hidden;
}

.sk-simple__content {
	width: 100%;
	padding: 40px;
	overflow-y: auto;
	backdrop-filter: blur(10px);
}
.sk-simple__content-title {
	font-size: 32px;
	text-align: center;
}

.sk-simple__header {
	width: 100%;
	padding-left: 50px;
}
.sk-simple__highlight {
	color: #000;
	text-shadow: #fff 2px 2px 3px;
	font-size: 32px;
	_margin-right: 200px;
}
.sk-simple__footer {
	display: flex;
	flex-direction: row;
	background-color: #3F3F3F;
	_border-top: 2px solid var(--main-color);
	border-top: 2px solid #fff;
	width: 100%;
	height: 100%;
	align-items: center;
	padding: 0 20px;
	overflow: hidden;
	position: fixed;
	height: 50px;
	bottom: 0;
	z-index: 50;
}
.sk-simple__logo-e {
	width: 200px;
	margin: 20px 0;
}
.sk-simple__logo {
	width: 30px;
}
.sk-simple__logo-text {
	flex: 1;
	color: #fff;
	margin: 0 20px;
}
.sk-simple__link-pp {
	color: #fff;
}

.sk-simple__content_header {
	display: flex;
	align-items: center;
	flex-direction: column;
}

@media screen and (max-width: 1024px) {
	.sk-simple__wrapper {
		max-height: 100%;
		height: fit-content;
		width: 100%;
		max-width: 480px;
	}
	.sk-simple__highlight {
		background-size: 100px;
	}
	.sk-simple__highlight-logo {
		height: 100px;
	}
	.sk-simple__content {
		min-height: fit-content;
		padding: 25px;
	}
	.sk-simple__logo-text {
		font-size: 10px;
	}
	.sk-simple__link-pp {
		font-size: 11px;
	}
}

@media screen and (max-width: 550px) {
	.sk-simple__highlight {
		text-align: center;
	}

	.sk-simple {
		grid-template-rows: 100px 1fr 130px;
	}
}

</style>


// WEBPACK FOOTER //
// src/components/shell/AppShellSimple.vue